import React, { ChangeEventHandler, FocusEvent, forwardRef } from 'react'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import styled from 'styled-components'
import useAutosizeTextAreaHook from 'src/hooks/useAutosizeTextArea.hook'

type TextAreaPropsType = CustomTextAreaProps & {
  value: string
}

export type CustomTextAreaProps = {
  width?: string
  placeholder?: string
  fontSize?: string
  margin?: string
  $padding?: string
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
  maxLength?: number
  onBlur?: (e: FocusEvent) => void
  onFocus?: (e: FocusEvent<HTMLElement>) => void
  disabled: boolean
  $min_height?: string
}

const TextArea = forwardRef(
  (props: TextAreaPropsType, msgInputRef: React.Ref<HTMLTextAreaElement>) => {
    useAutosizeTextAreaHook((msgInputRef as any).current, props.value)

    return (
      <TextAreaWrap>
        <CustomTextArea
          {...props}
          ref={msgInputRef}
          disabled={props.disabled}
          onChange={props.onChange}
          value={props.value}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
        />
        <Span
          option={'tiny'}
          color={COLOR.bluegray30}
          $margin={'10px auto 12px auto'}
          $text_align={'right'}
        >
          {props.value.length}/200
        </Span>
      </TextAreaWrap>
    )
  },
)

export default TextArea

const TextAreaWrap = styled.div`
  display: block;
  width: 100%;
`

const CustomTextArea = styled.textarea<CustomTextAreaProps>`
  margin: ${(props) => props.margin || 0};
  padding: ${(props) => props.$padding || 0};
  font-size: ${(props) => props.fontSize};
  width: ${(props) => props.width || '100%'};
  min-height: ${(props) => props.$min_height};
  border-radius: 12px;
  overflow: hidden;
  background-color: ${COLOR.black2};
  outline: none;
  border: 1px solid ${COLOR.black20};
`
